import React, { useEffect, useState } from "react";
import { wire } from "react-hot-wire";

import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

import { DrawerService } from "services/drawer/Drawer.service";

function Drawer({
  render,
  drawerService,
  name,
  ...props
}: {
  render: ({ close }: { close: () => void }) => React.ReactNode;
  drawerService: DrawerService;
  name: string;
}) {
  const [isOpen, setOpenState] = useState(false);
  const open = () => setOpenState(true);
  const close = () => {
    setOpenState(false);
    drawerService.close(name);
  };

  useEffect(open, []);

  return (
    <SwipeableDrawer
      open={isOpen}
      PaperProps={{
        style: {
          width: "55%"
        }
      }}
      onOpen={open}
      onClose={close}
      anchor="right"
      {...props}
    >
      {render({
        close
      })}
    </SwipeableDrawer>
  );
}

export default wire(["drawerService"], Drawer);
